var statusCodes = Object.freeze({
   Unauthorized: 401,
   UnprocessableEntity: 422
});

export default statusCodes;
